import { IAdminUser, ICreateAdminUser, IUpdateAdminUser, IDeleteAdminUser } from "./IAdminUser";
import { HTTPService } from "../../common/services/httpService";
import { CommonConstants } from "../../common/constants/common-constants";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";

const httpService = new HTTPService();

const getAdminUsers = (): Promise<IHTTPResponse<IAPIResponse<IAdminUser>>> =>
    httpService.get(`${CommonConstants.BaseAddress}/AdminUser/list`);

const createAdminUser = (user: ICreateAdminUser) =>
    httpService.post(`${CommonConstants.BaseAddress}/AdminUser/Create`, user);

const updateAdminUser = (user: IUpdateAdminUser) =>
    httpService.post(`${CommonConstants.BaseAddress}/AdminUser/Update`, user);

const deleteAdminUser = (user: IDeleteAdminUser) =>
    httpService.post(`${CommonConstants.BaseAddress}/AdminUser/Delete`, user);

export const AdminUserService = {
    getAdminUsers,
    createAdminUser,
    updateAdminUser,
    deleteAdminUser
};